<template lang="pug">
div(:contenteditable="editable" @keyup.stop="noop" :style="{ fontSize }" v-html="title").page-section-title 
</template>

<script>
export default {
  name: 'PageSectionTitle',
  props: {
    title: { type: String, default: '' },
    editable: { type: Boolean, default: false },
    fontSize: { type: String, default: '2em' },
  },
  methods: {
    noop() {},
  },
}
</script>

<style lang="scss" scoped>
.page-section-title {
  font-size: 2em;
  line-height: 1.6;
  margin: 0.5em;
  padding: 0 1em;
  font-weight: bolder;
  text-align: center;
  ::v-deep div + div {
    font-size: 0.8em;
  }
}
</style>
